export class ContactForm {
  private messageField: HTMLInputElement;

  constructor() {
    this.messageField = document.getElementById("message") as HTMLInputElement;
    if (!this.messageField) {
      return;
    }

    this.init(this.messageField);
  }
  public init(messageField: HTMLInputElement): void {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const messageParam = urlSearchParams.get("message");
    if (messageField) {
      messageField.value = messageParam;
    }
    // scroll to this .contact-form section if the messageParam is set
    if (messageParam) {
      const contactForm = document.querySelector(".contact-form");
      contactForm?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
}
